import React from "react";
import { Title } from "@components/ui";
import InfoSection from "@components/pages/info/info_section";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import ServiceHeader from "@components/pages/info/services/service_header";
import Head from "next/head";
import { WEBPAGE_TITLE } from "@utils/constants";

function ServiceNumber() {
    return (
        <>
            <Head>
                <title key="site_title">Sýnileiki á miðlum 1819 - {WEBPAGE_TITLE}</title>
            </Head>

            <InfoSection>
                <ServiceHeader
                    image="/img/thjonusta/synileiki.png"
                    title="Sýnileiki á miðlum 1819"
                />
                <p>NÆLDU ÞÉR Í VIÐSKIPTAVINI MEÐ RÉTTUM LEITARORÐUM</p>
                <p>
                    Sýnileikapakkar 1819 gefa fyrirtækjum möguleika á því velja hversu áberandi
                    þeirra skráning birtist í leitarniðurstöðum á 1819.is og í 1819 appinu.
                    Fyrirtækjum gefst með þessu tækifæri til þess að vera ofar í huga notenda þegar
                    að þeir leita sér að vörum og þjónustu.
                </p>
                <p>
                    Við leggjum áherslu á að allar helstu upplýsingar sem fyrirtæki þurfa að koma á
                    framfæri séu settar fram á skýran og snyrtilegan hátt. Í samstarfi við
                    fyrirtækið er vörumerkjasíða þess sett upp á fagmannlegan máta með nýjustu
                    upplýsingum um fyrirtækið. Vörumerkjasíða fyrirtækis hjá 1819 er leitarvélarvæn
                    og aðgengileg fyrir notendur - hvort sem þeir nálgast upplýsingarnar í
                    snjallsíma, tölvu eða með spjaldtölvu. Leitarorð eru góður kostur fyrir
                    fyrirtæki til þess að auka vitund landsmanna um þjónustu sem boðið er upp á sem
                    og vöruúrval. Að notast við leitarorð er árangursrík leið fyrir fyrirtæki til
                    þess að næla sér í nýja viðskiptavini sem oft á tíðum eru að leita eftir
                    ákveðinni vöru eða þjónustu en hafa ekki eitt ákveðið fyrirtæki eða
                    þjónustuaðila í huga.
                </p>
            </InfoSection>
            <InfoSection>
                <Title size={4}>
                    1819 býður fyrirtækjum upp á val á milli nokkurra ólíkra sýnileikapakka
                </Title>
                <table className="table packages-1819-table">
                    <thead>
                        <tr>
                            <td>Pakkar</td>
                            <td>Sýnilegur</td>
                            <td>Góður</td>
                            <td>Betri</td>
                            <td>Bestur</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Sýnileiki *</td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                        </tr>
                        <tr>
                            <td>SMS gátt **</td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                        </tr>
                        <tr>
                            <td>Auglýsingainneign ***</td>
                            <td>1 vika</td>
                            <td>2 vikur</td>
                            <td>3 vikur</td>
                            <td>4 vikur</td>
                        </tr>{" "}
                        <tr>
                            <td>- Pláss 1</td>
                            <td></td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                        </tr>{" "}
                        <tr>
                            <td>- Pláss 2</td>
                            <td></td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                        </tr>{" "}
                        <tr>
                            <td>- Pláss 3</td>
                            <td></td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                        </tr>{" "}
                        <tr>
                            <td>Árs-leitarorða auglýsing</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                        </tr>{" "}
                        <tr>
                            <td>Merki/lógó fyrirtækis</td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                        </tr>{" "}
                        <tr>
                            <td>Mynd í haus/borði</td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                        </tr>{" "}
                        <tr>
                            <td>Bakgrunnslitur að eigin vali</td>
                            <td></td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                        </tr>{" "}
                        <tr>
                            <td>Upplýsingatexti og myndir</td>
                            <td></td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                        </tr>{" "}
                        <tr>
                            <td>Slagorð á vörumerkjasíðu</td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                        </tr>{" "}
                        <tr>
                            <td>Vöru og þjónustuheiti á allt að</td>
                            <td>20</td>
                            <td>30</td>
                            <td>40</td>
                            <td>Ótakmarkað</td>
                        </tr>{" "}
                        <tr>
                            <td>Veffang</td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                        </tr>{" "}
                        <tr>
                            <td>Netfang</td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                        </tr>{" "}
                        <tr>
                            <td>Opnunartími</td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                        </tr>{" "}
                        <tr>
                            <td>Tenging við samfélagsmiðla</td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                        </tr>{" "}
                        <tr>
                            <td>Viðbótarnúmer/útibú</td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                            <td>
                                <FontAwesomeIcon icon={faCheck} />
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>Verð á ári (án vsk.)</td>
                            <td>174.900 kr.</td>
                            <td>260.000 kr.</td>
                            <td>350.500 kr.</td>
                            <td>472.500 kr.</td>
                        </tr>
                    </tfoot>
                </table>
            </InfoSection>
            <InfoSection title="Verðskrá">
                <table className="table">
                    <thead>
                        <tr>
                            <td>Þjónusta</td>
                            <td>Verð án vsk.</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Merki / lógó fyrirtækis</td>
                            <td>57.000 kr.</td>
                        </tr>{" "}
                        <tr>
                            <td>Haus / borði (Banner)</td>
                            <td>20.700 kr.</td>
                        </tr>{" "}
                        <tr>
                            <td>Bakgrunnslitur að eigin vali</td>
                            <td>11.900 kr.</td>
                        </tr>{" "}
                        <tr>
                            <td>Upplýsingatexti og myndir</td>
                            <td>22.900 kr.</td>
                        </tr>{" "}
                        <tr>
                            <td>Slagorð á vörumerkjasíðu</td>
                            <td>11.400 kr.</td>
                        </tr>{" "}
                        <tr>
                            <td>Veffang</td>
                            <td>0 kr.</td>
                        </tr>{" "}
                        <tr>
                            <td>Netfang</td>
                            <td>0 kr.</td>
                        </tr>{" "}
                        <tr>
                            <td>Opnunartími</td>
                            <td>0 kr.</td>
                        </tr>{" "}
                        <tr>
                            <td>Tenging við samfélagsmiðla</td>
                            <td>0 kr.</td>
                        </tr>{" "}
                        <tr>
                            <td>Vöru- og þjónustuheiti á allt að (Leitarorð)</td>
                            <td>2.700 kr.</td>
                        </tr>{" "}
                        <tr>
                            <td>Viðbótarnúmer / útibú</td>
                            <td>12.400 kr.</td>
                        </tr>{" "}
                        <tr>
                            <td>Hönnun á logo / vefborða</td>
                            <td>10.900 kr.</td>
                        </tr>
                    </tbody>
                </table>
                Öll verð eru á ársgrundvelli og án vsk.
            </InfoSection>
            <InfoSection title="Skýringar á einstökum liðum á vörumerkjasíðu">
                <Title size={5}>Merki / lógó fyrirtækis</Title>
                <p>
                    Vörumerki fyrirtækja er eitt helsta tákn sem situr í huga fólks þegar það hugsar
                    um fyrirtækið.
                </p>{" "}
                <Title size={5}>Mynd í haus / borði</Title>
                <p>
                    Stór auglýsingaborði sem kemur ímynd fyrirtækisins á framfæri og birtist þegar
                    fyrirtækið er skoðað nánar.
                </p>{" "}
                <Title size={5}>Bakgrunnslitur að eigin vali</Title>
                <p>
                    Hægt er að breyta litnum á bak við vörumerkjasíðuna og tengja þannig við
                    vörumerkið.
                </p>{" "}
                <Title size={5}>Upplýsingatexti og myndir</Title>
                <p>
                    Hór er hægt að tengja saman sögu fyrirtækisins við myndir úr starfseminni og
                    gefa þannig betri mynd af rokstrinum, þjónustum og vörum.
                </p>{" "}
                <Title size={5}>Slagorð sem birtist á vörumerkjasíðu</Title>
                <p>
                    Flest fyrirtæki eiga sér slagorð sem þau standa fyrir og er upplagt að koma þeim
                    á framfæri við vörumerki fyrirtækja.
                </p>{" "}
                <Title size={5}>Veffang</Title>
                <p>
                    Flest fyrirtæki hafa vefsíðu þar sem fjallað er um fyrirtækin á ítarlegri hátt
                    en rúmast á vörumerkjasíðu og nauðsynlegt að koma því á framfæri.
                </p>{" "}
                <Title size={5}>Netfang</Title>
                <p>
                    Fyrirtæki hafa yfirleitt sín eigin netföng svo þeirra viðskiptavinir geti haft
                    beint samband. Oft er heppilegt að birta netföng helstu starfsmanna.
                </p>{" "}
                <Title size={5}>Opnunartími</Title>
                <p>
                    Þægilegt er að sjá strax hvort það só opið eða lokað þegar verið er að fletta
                    upp fyrirtækjum á 1819.ÍS og sjá líka opnunartímann.
                </p>{" "}
                <Title size={5}>Tenging við samfélagsmiðla (hlekkir)</Title>
                <p>
                    Fyrirtæki eru oft með sína eigin síðu á Facebook, Twitter eða öðrum
                    samfélags-miðlum og vilja vera sýnileg með því að gefa upp hlekkina.
                </p>{" "}
                <Title size={5}>Vöru- og þjónustuheiti</Title>
                <p>
                    Vöru- og þjónustuheiti virka eins og leitarorð. Mikilvægt er að velja viðeigandi
                    leitarorð svo viðskiptavinir finni þá þjónustu og vörur sem þeira leita að og að
                    þitt fyrirtæki beri hag af.
                </p>{" "}
                <Title size={5}>Viðbótarnúmer / útibú</Title>
                <p>
                    Hægt er að sýna öll þau viðbótanúmer fyrir starfsemina og útibú þess sem
                    nauðsynlegt er að birta auk viðbótarnúmera fyrir lykilstarfsmenn.
                </p>
            </InfoSection>
        </>
    );
}
export default ServiceNumber;
